export const FOOTER_COLOR = `#011949`;
export const FOOTER_LINE_COLOR = `white`;
export const FOOTER_LINE = {
    width: "100%", borderBottom: `1px solid ${FOOTER_LINE_COLOR}`,
};